import { render, staticRenderFns } from "./WTextarea.vue?vue&type=template&id=42b049b8&scoped=true&"
import script from "./WTextarea.vue?vue&type=script&lang=js&"
export * from "./WTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b049b8",
  null
  
)

export default component.exports